import { Component, HostListener, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Platform, NavController, AlertController } from '@ionic/angular';
import { isPlatformBrowser, Location } from '@angular/common';
import { ScreensizeService } from './helpers/screensize.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { NoInternetPopupComponent } from './no-internet-popup/no-internet-popup.component';
// import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { CleverTap } from '@awesome-cordova-plugins/clevertap/ngx';
import { ToasterService } from './helpers/toaster.service';
import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { StorageServiceAAA } from './helpers/aaa-storage.service';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { AnalyticsService } from './helpers/analytics.service';
import { UpdateVersionService } from './helpers/updateversion.service';
import { Appsflyer } from '@awesome-cordova-plugins/appsflyer/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style} from '@capacitor/status-bar';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { CommonService } from './helpers/common.service';

@Component({
	standalone: false,
	selector: 'app-root',
	providers: [AnalyticsService, UpdateVersionService],
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent {
	private readonly isBrowser: boolean;

	public lastBack = null;
	public internetModal: any;
	public getFeed: any;
	newValue: any
	oldValue: any;
	seconds: any;
	timeDiff: any;
	timeArray: any[] = [];
	alertOpen:boolean = false;
	constructor(
		private platform: Platform,
		private storage: StorageServiceAAA,
		private screensize: ScreensizeService,
		private navCtrl: NavController,
		public route: Router,
		private titleService: Title,
		private ngZone: NgZone,
		private network: Network,
		private alertController: AlertController,
		public modalController: ModalController,
		private analytics: AnalyticsService,
		private updateVerSer: UpdateVersionService,
		// private firebaseX: FirebaseX,
		private mobClevertap: CleverTap,
		private toast: ToasterService,
		public faio: FingerprintAIO,
		private _location: Location,
		private appsflyer: Appsflyer,
		private commonService: CommonService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
		if (this.isBrowser) {
			import('swiper/element/bundle').then(({ register }) => register());
		}
		if (this.isBrowser && !this.commonService.get('jwtToken') && window.location.hash) {
			const fragment = window.location.hash.substring(1); // Remove #
			const params = new URLSearchParams(fragment);
			const accessToken = params.get('access_token');
			const idToken = params.get('id_token');
			const expiresIn = params.get('expires_in');
			
			if (accessToken) {
				this.commonService.set('jwtToken', accessToken);
				if (idToken) {
					this.commonService.set('id_token', idToken);
				}
				if (expiresIn) {
					const expiryTime = new Date().getTime() + (parseInt(expiresIn) * 1000);
					this.commonService.set('token_expiry', expiryTime.toString());
				}
				this.commonService.set('isOneLogin', 'true');
				// Clean up URL fragment for security
				window.history.replaceState({}, document.title, window.location.pathname);
			}
		}
		if (this.isBrowser) {
			this.platform.backButton.subscribeWithPriority(10, () => {
			
				if(this.route.url == '/login' || this.route.url == '/dashboard' ){
					if(!this.alertOpen){
						this.showExitConfirm();
					}
					
				
				}
				else{
					this._location.back();
					//history.back();
				}
			})
			clearTimeout(this.getFeed);
			this.initializeApp();
		}
	}

	showExitConfirm() {
		this.alertOpen = true;
		this.alertController.create({
		  message: 'Do you want to close the app?',
		  backdropDismiss: false,
		  buttons: [{
			text: 'Close',
			role: 'cancel',
			handler: () => {
				this.alertOpen = false;
			//   console.log('Application exit prevented!');
			}
		  }, {
			text: 'Exit',
			handler: () => {
			  if (this.isBrowser && (navigator as any)['app']) {
				(navigator as any)['app'].exitApp();
			  }
			}
		  }]
		})
		  .then((alert: any) => {
			alert.present();
		  });
	  }

	initializeApp() {
		if (!this.isBrowser) {
			return;
		}

		this.platform.ready().then(() => {
			this.updateVerSer.checkForUpdate();
			this.setupDeepLink();
			if(Capacitor.getPlatform() !== 'web' && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone') )){
			const statusBarColor: string = "#524091";
			StatusBar.setBackgroundColor({ color: statusBarColor.toString()});
            StatusBar.setStyle({ style: Style.Dark });
			if(this.platform.is("android")){
				StatusBar.setOverlaysWebView({ overlay: false });
				SplashScreen.hide();
			}
			if(this.platform.is("ios") || this.platform.is('ipad') || this.platform.is('iphone')){
				SplashScreen.show({
					showDuration: 2000,
					autoHide: true
				});
			}
			StatusBar.show();
		}
			this.mobClevertap.notifyDeviceReady();
			
			const appsflyerOptions = this.getAppsflyerOptions();
			if(appsflyerOptions != undefined) this.appsflyer.initSdk(appsflyerOptions);	
			this.screensize.onResize(this.platform.width());
			// console.log = function() {};

			this.ngZone.run(() => {
				this.storage.get('token').then((response) => {
					if (response) {
						this.storage.get('deviceLock').then( isLock => {
							if (isLock) {
								this.fingerPrintAccess();
							} else {
		
								const path = this.route.url;
		
								if (path === '/login') {
									this.navCtrl.navigateRoot(['/login'])
								} else {
									if(this.route.url == '/family-portfolio'){
										this.route.navigate(['/dashboard']);	
									}
									else{
									}
								}
							}
						})
						// }
					} else {
						const path = this.route.url;
						if (!this.platform.is('desktop')) {
							// this.commonService.clear();
						};

					}

					this.checkTime();
				})
				// console.log(this.firebaseX)
				// this.firebaseX.grantPermission()
				// upgrade error
				// this.firebaseX['setAnalyticsCollectionEnabled'](true);
				// this.firebaseX.logError('App crashed')
				// upgrade error
				// this.fetchRemoteConfig();
			})

			// this.navCtrl.navigateRoot(['/login'])
			// if (path === '/') 
			// else this.navCtrl.navigateRoot([path]);
			this.screensize.onResize(this.platform.width());
		});
		// watch network for a disconnection
		let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
			// console.log('no internet');

			this.noInternet();
		});

		// stop disconnect watch
		// disconnectSubscription.unsubscribe();


		// watch network for a connection
		let connectSubscription = this.network.onConnect().subscribe(() => {
			// We just got a connection but we need to wait briefly
			// before we determine the connection type. Might need to wait.
			// prior to doing any api requests as well.
			// console.log('connect', this.network);

			if (this.network.type === 'wifi') {
				setTimeout(() => {
					this.internetModal.dismiss();
				}, 3000);
			} else {
				this.internetModal.dismiss();
			}
		});



		// google analytic 
		this.analytics.init();
	}

	setupDeepLink() {
		if (!this.isBrowser) {
			return;
		}
		App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
			this.ngZone.run(() => {
				// Example url: https://beerswift.app/deeplink/42
				// slug = /tabs/tab2
				const slug = event.url.split(".com").pop();
				if (slug) {
					this.route.navigateByUrl(slug);
				}
				// If no match, do nothing - let regular routing
				// logic take over
			});
		});
	}

	public fingerPrintAccess(data?: any,skipLogin?: any) {
		this.faio.isAvailable({requireStrongBiometrics: true})
			.then((result: any) => {
				if (result === "finger" || result === "face" || result === "biometric") {
					this.faio.show({
						title: 'Please verify to login',
						// clientSecret: 'password', //Only necessary for Android
						disableBackup: true,  //Only for Android(optional)
						fallbackButtonTitle: 'Use Pin', //Only for iOS
						// localizedReason: 'Please authenticate' //Only for iOS
					})
						.then((result1: any) => {
							// alert(result1 + ' Success RESULT  ');
							if (result1 == 'biometric_success') {
								// this.storage.set('safetyLock', this.loginPinInput);
								// this.storage.set('deviceLock', true);
								this.navCtrl.navigateRoot(['/dashboard']);
								//Quick Login has successfully Enabled.
							} else {
								// console.log(' Storage clear ');
								this.storage.set('deviceLock', false);
								this.storage.clear();
								this.navCtrl.navigateRoot(['/login']);
							}
							// this.commonService.set('fingerprintdata', result.withFingerprint);

							// console.log(this.commonService.get('fingerprintdata'));
							//alert("Successfully Authenticated!")
						})
						.catch((error: any) => {
							// console.log('Please enable the Fingerprint/FaceID feature in your mobile ' , error);
							this.navCtrl.navigateRoot(['/login']);
							// this.toast.displayToast('Please enable the Fingerprint feature in your mobile');

							//this.commonService.toastFuntion('Please enable the Fingerprint/FaceID feature in your mobile ');
							//alert("Match not found!")
						});
					// .then((result: any) => {
					//     console.log(result);
					//     this.commonService.set('fingerprintdata', result.withFingerprint);

					// .catch((error: any) => {
					//     console.log(error);
					//     this.commonService.toastFuntion('Please enable the Fingerprint/FaceID feature in your mobile ');
					// });
				}
			}).catch((err: any) => {
				// console.log('Fingerprint/ FaceID authorization is not available on this device', err);
				// this.navCtrl.navigateRoot(['/login']);
				// this.commonService.toastFuntion("Fingerprint/ FaceID authorization is not available on this device");
			});

	}

	@HostListener(':resize', ['$event'])
	onResize(event: any) {
		this.screensize.onResize(event.target.innerWidth);
	}

	async presentAlert() {
		const alert = await this.alertController.create({
			header: 'No Internet Connection',
			message: 'Please Check Your Internet Connection!.',
			buttons: [
				{
					text: 'Retry',
					role: 'retry',
					cssClass: 'secondary',
					handler: () => {
						if (this.network.type === 'none') {
							this.presentAlert();
						}
					}
				}
			]
		});
		if (alert) {
			alert.dismiss();
		}
		alert.present();
	}

	// No Internet Connection Popup
	async noInternet() {
		// const element = await this.internetModal.getTop();
		// if (element !== null && element !== undefined) {
		//   element.dismiss();
		// }
		if (this.internetModal) {
			const element = await this.internetModal.getTop();
			element.dismiss();
		}
		this.internetModal = await this.modalController.create({
			backdropDismiss: false,
			component: NoInternetPopupComponent,
			cssClass: 'overlay-modal',
		});
		this.internetModal.onDidDismiss()
			.then((data: any) => {
				this.internetModal = undefined;
			}
			);
		return await this.internetModal.present();
	}

	public checkTime() {
		this.storage.get('loginTime').then(value => {
			if (value) {
				this.newValue = new Date();
				this.oldValue = new Date(value);
				var diff = (this.newValue.getTime() - this.oldValue.getTime());
				var res = Math.abs(this.newValue - this.oldValue) / 1000;
				// Epoche Time Difference
				this.timeDiff = (Math.abs(this.newValue - this.oldValue) / 1000);
				// var days = Math.floor(res / 86400);

				// // get hours        
				// var hours = Math.floor(res / 3600) % 24;

				// // get minutes
				// var minutes = Math.floor(res / 60) % 60;
				// // get seconds
				// this.seconds = res % 60;


				// calculate 8 hours (60*60*8 = 28800) after session start
				if (parseInt(this.timeDiff) > 28800) {
					
					// push the time to array which is more than 28800
					this.timeArray.push(parseInt(this.timeDiff));
					clearTimeout(this.getFeed);
					if (parseInt(this.timeDiff) == this.timeArray[this.timeArray.length-1])
						this.storage.get('userType').then(user => {
						// Reset DashTabSelect before clearing storage
						this.commonService.remove('DashTabSelect');
						this.storage.clear();
						this.commonService.clear();
						if (this.platform.is('desktop')) {
							this.toast.displayToast('Session has Expired Please Login Again');
							this.route.navigateByUrl('/login')
						}
						else{
								this.commonService.set('sessionExpire', 'true');
								this.toast.displayToast('Session has Expired Please Login Again');
								this.route.navigateByUrl('/login')
							}
						})
				}
			}
			clearTimeout(this.getFeed);
			this.getFeed = setTimeout(() => {
				this.checkTime();
			}, 1000)
		})
	}

	async sessionExpired(user: any) {
		this.modalController.dismiss();
		const modal = await this.modalController.create({
			component: SessionExpiredComponent,
			backdropDismiss: false,
			cssClass: 'forgot-password-popup-mobile session-expired',
			componentProps: {
				userType: user
			}
		});
		// this.storage.clear();

		/* modal.onDidDismiss().then((data) => {
			if (data['data']) {
				console.log(data['data']);

			}
		}) */

		return await modal.present();
	}

	// upgrade error
	// async fetchRemoteConfig() {
	// 	await this.firebaseX.fetch().then((result: any) => {
	// 		this.firebaseX.activateFetched().then((xyz: any) => {
	// 			this.firebaseX.getValue("app_update_versions").then((value: any) => {
	// 				// alert(value + "app_update_versions");
	// 				// console.log("app_update_versions", value);
	// 				if (value) {
	// 					let app_version = JSON.parse(value);
	// 					this.updateVerSer.checkVersionUpdate(app_version);
	// 					// console.log(app_version);
	// 				}
	// 			})
	// 		})
	// 	})
	// }

	// public setTitle( newTitle: string) {
	//   this.titleService.setTitle( newTitle );
	// }

	private getAppsflyerOptions = () => {

		let options: any = undefined;
		if(this.platform.is('android') || this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone')){
			options = {};
			if(this.platform.is('android')){

				options['devKey'] = '6iaGn35tdE5XPxFMT66nTA'; // your AppsFlyer devKey 
				// options['isDebug'] = true;
				return options;
			}
			if(this.platform.is('ios')){

				options['devKey'] = '6iaGn35tdE5XPxFMT66nTA'; // your AppsFlyer devKey.
				// options['isDebug'] = true;
				options['appId'] = '1563765662'; // your ios appID
				options['waitForATTUserAuthorization'] = 80; //time for the sdk to wait before launch - IOS 14 ONLY!
				return options;
			}
		} else {
			return options;
		}
	}

}

